/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Widget_Empty_TasksInputs */

const cs_dashboard_widget_empty_tasks = /** @type {(inputs: Dashboard_Widget_Empty_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na dnešek nemáte žádné úkoly.`)
};

const en_dashboard_widget_empty_tasks = /** @type {(inputs: Dashboard_Widget_Empty_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing on today's agenda.`)
};

/**
* | output |
* | --- |
* | "Nothing on today's agenda." |
*
* @param {Dashboard_Widget_Empty_TasksInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_widget_empty_tasks = /** @type {((inputs?: Dashboard_Widget_Empty_TasksInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Widget_Empty_TasksInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_widget_empty_tasks(inputs)
	return cs_dashboard_widget_empty_tasks(inputs)
});